export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8729.780a322e.jpg";